export default "__VITE_ASSET__DCkFmNbl__"